export const MAX_INPUT_LENGTH = 10000;

export const CHAT_SUGGESTIONS = [
  'Show the top 10 most expensive clusters',
  'Show me the cost trend for the last 30 days',
  'What is my total Kubernetes spend this month?',
];
